import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { Container, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import ProductTypeFormContentView from './Includes/ProductTypeFormContentView'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    PRODUCTTYPE_ADDED_SUCCESSFULLY,
    ERROR_WHILE_CREATING_PRODUCTTYPE
} from 'utlis/AppMessages/AppMessages'
import { createFormValidationSchema, initialCreateFormValues } from './FormHelper'
import { addProductType } from 'utlis/Apis/ProductTypes_API'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

function AddProductType(props) {
    // props
    const { authState } = props

    const submitButtonRef = useRef(null)
    const [createButtonDisable, setCreateButtonDisable] = useState(false)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)

    // store url
    const [storeUrl] = useStoreUrl()

    const onCreateFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setCreateButtonDisable(true)
            setCreateButtonLoading(true)
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            addProductType(headers, values).then(res => {
                setGlobalLoading(false)

                const productTypeData = res.data
                if (productTypeData.success) {
                    setCreateButtonLoading(false)
                    window.scrollTo(0, 0)
                    props.history.push(storeUrl + '/settings/product-types', {
                        shouldReload: true
                    })
                    formik.resetForm()
                    toast.dismiss();
                    toast.success(PRODUCTTYPE_ADDED_SUCCESSFULLY, {
                        autoClose: 2000,
                        onClose: () => {

                        }
                    })
                }
                if (productTypeData.error) {
                    console.log(ERROR_WHILE_CREATING_PRODUCTTYPE, res)
                    setCreateButtonDisable(false)
                    setCreateButtonLoading(false)
                    toast.dismiss();
                    toast.error(ERROR_WHILE_CREATING_PRODUCTTYPE, {
                        autoClose: 3000,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} productType `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setGlobalLoading(false)
                        setCreateButtonDisable(false)
                        setCreateButtonLoading(false)
                    }
                })
            })
        }
    }

    const formik = useFormik({
        initialValues: initialCreateFormValues,
        validationSchema: createFormValidationSchema,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }

    return (
        <section id="app-Status__create-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-Status__create-details">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Add Product Type</p>
                        <p className="app-desc">
                        </p>
                    </div>
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <ProductTypeFormContentView
                                formik={formik}
                            />
                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to={storeUrl + "/settings/product-types"} className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={createButtonDisable}
                                        onClick={handleFormSubmission}>
                                        {
                                            createButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Add Product Type</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddProductType)